import { Button, Form, Input, Modal } from "antd";
import { ICreateProductionProjectMember } from "../../models/Production";
import { useCreateProductionProjectMember } from "../../query/ProductionQuery";
import { notify } from "../../utils/toast";

interface IModalAddProductionMemberProps {
  open: boolean;
  onCancel: () => void;
  projectId: number;
}

const ModalAddProductionMember = ({
  open,
  onCancel,
  projectId,
}: IModalAddProductionMemberProps) => {
  const [form] = Form.useForm();
  const createMemberMutation = useCreateProductionProjectMember();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const data: ICreateProductionProjectMember = {
        prdProjectId: projectId,
        fullName: values.fullName,
        role: values.role,
        phone: values.phone,
      };

      await createMemberMutation.mutateAsync(data);
      notify.success("Thêm thành viên thành công");
      onCancel();
      form.resetFields();
    } catch (error) {
      notify.error("Thêm thành viên thất bại");
    }
  };

  return (
    <Modal
      title="Thêm thành viên dự án"
      open={open}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onCancel();
            form.resetFields();
          }}
        >
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={createMemberMutation.isPending}
        >
          Thêm
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Họ và tên"
          name="fullName"
          rules={[{ required: true, message: "Vui lòng nhập họ và tên" }]}
        >
          <Input placeholder="Nhập họ và tên" />
        </Form.Item>

        <Form.Item
          label="Vai trò"
          name="role"
          rules={[{ required: true, message: "Vui lòng nhập vai trò" }]}
        >
          <Input placeholder="Nhập vai trò (VD: Project Manager, Developer...)" />
        </Form.Item>

        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[
            { required: true, message: "Vui lòng nhập số điện thoại" },
            {
              pattern: /^[0-9]{10,11}$/,
              message: "Số điện thoại không hợp lệ",
            },
          ]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddProductionMember;
